/*!
 * Jodit Editor (https://xdsoft.net/jodit/)
 * Released under MIT see LICENSE.txt in the project root for license information.
 * Copyright (c) 2013-2026 Valerii Chupurnov. All rights reserved. https://xdsoft.net
 */
/**
 * @module plugins/image-processor
 */
import { Config } from "../../config.js";
Config.prototype.imageProcessor = {
    replaceDataURIToBlobIdInView: true
};
